import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Section } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'
import { PERSON_TYPE } from '../constants'
import { H6, P } from '@PipelineDeals/shared-react-components'

const Tags = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields, showEmptyFields }, resource, resourceType } = useBusinessCard()

  const fieldName = resourceType === PERSON_TYPE ? 'predefined_contacts_tag_ids' : 'tag_ids'
  const tags = useMemo(() => resourceType === PERSON_TYPE ? resource.predefined_contacts_tags : resource.tags, [resource, resourceType])

  if (!showOnlyFields.includes(fieldName)) return null
  if (!showEmptyFields && (!tags || !tags.length)) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.tags')}</H6>
      <P>
        {tags.map(tag => tag.name).join(', ')}
      </P>
    </Section>
  )
}

export default Tags
